import { CFormInput, CFormSelect } from '@coreui/react';
import type { Schemas } from '../api/client';

/**
 * Věc na míru (speciální senzor, napájecí box), která v portálovém číselníku není.
 * Server ji pozná podle typu 0 a název si vezme z textu (zpětná vazba 15. 10. 2026).
 */
export const CUSTOM_DEVICE_TYPE = 0;

/** Výběr zařízení z portálu + volba „Nová (na míru)…“ s polem pro název. */
export function DeviceTypeSelect({ deviceTypes, value, customName, onChange, size, placeholder }: {
  deviceTypes: Schemas['DeviceTypeLookup'][] | undefined;
  value: number | '';
  customName: string;
  onChange: (value: number | '', customName: string) => void;
  size?: 'sm';
  placeholder: string;
}) {
  return (
    <>
      <CFormSelect size={size} value={value} aria-label="Zařízení"
        onChange={(e) => onChange(e.target.value === '' ? '' : Number(e.target.value), customName)}>
        <option value="">{placeholder}</option>
        {deviceTypes?.map((d) => <option key={d.portalDeviceTypeId} value={d.portalDeviceTypeId}>{d.name}</option>)}
        {deviceTypes?.length === 0 && <option disabled>Zařízení z portálu se teď nepodařilo načíst</option>}
        <option value={CUSTOM_DEVICE_TYPE}>Nová (na míru)…</option>
      </CFormSelect>
      {value === CUSTOM_DEVICE_TYPE && (
        <CFormInput size={size} className="mt-2" autoFocus maxLength={128}
          placeholder="Co to je, např. Napájecí box 24 V" aria-label="Název věci na míru"
          value={customName} onChange={(e) => onChange(value, e.target.value)} />
      )}
    </>
  );
}

/** Položka je vyplněná: vybrané zařízení, u věci na míru i název. */
export const deviceChosen = (value: number | '', customName: string) =>
  value !== '' && (value !== CUSTOM_DEVICE_TYPE || customName.trim() !== '');
